<template>
  <div class="news">
    <div id="lbs-header" />
    <div class="news-list">
      <div class="news-header">
        <h1>公告中心</h1>
      </div>
      <div v-if="!isNewsDetailShow">
        <div class="news-list-content">
          <img
            v-if="newsList.length === 0"
            class="news-list-img"
            src="../img/news_empty.png"
          >
          <ul
            v-else
            class="news-list-ul"
          >
            <li
              v-for="(item, index) in newsList"
              :key="index"
            >
              <a
                :href="item.path"
                target="_blank"
              >
                <div class="article-title">
                  {{ item.title }}
                  <div class="article-time">
                    {{ item.pubtime }}
                  </div>
                </div>
                <div class="article-message">
                  {{ item.desc ? item.desc : '暂无' }}
                </div>
                <div class="line" />
              </a>
            </li>
          </ul>
          <el-pagination
            id="pagination"
            :hide-on-single-page="true"
            :total="totalItem"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="prev, pager, next"
            @current-change="onChangePage"
            @prev-click="onChangePage"
            @next-click="onChangePage"
          />
        </div>
      </div>
      <div v-else>
        <div class="news-list-content">
          <div class="title-nav">
            <router-link :to="`/news/${modulePath}`">
              公告中心 >
            </router-link>
            详情
          </div>
          <!-- eslint-disable -->
          <div class="article-container custom-html-style" v-html="articleInfo.html" />
        </div>
        <div class="news-footer">
            <p v-if="articleInfo.preArticleName">
                上一篇：
                <a v-if="isExternalLink(articleInfo.preArticlePath)" :href="articleInfo.preArticlePath">{{ articleInfo.preArticleName }}</a>
                <router-link v-else :to="articleInfo.preArticlePath">{{ articleInfo.preArticleName }}</router-link>
            </p>
            <p v-if="articleInfo.nextArticleName">
                下一篇：
                <a v-if="isExternalLink(articleInfo.nextArticlePath)" :href="articleInfo.nextArticlePath">{{ articleInfo.nextArticleName }}</a>
                <router-link v-else :to="articleInfo.nextArticlePath">{{ articleInfo.nextArticleName }}</router-link>
            </p>
        </div>
        </div>
    </div>
    <div id="lbs-footer" />
  </div>
</div>
</template>

<script>
import { getCategoryListApi, getArticleListApi, getArticleContentApi } from '~/service/doc-service';
import util from '~/utils/index';
import { errorLogger } from '~/utils/logger';

const PAGE_SIZE = 10;

export default {
  layout: 'default',
  middleware: 'handleHost',
  // eslint-disable-next-line complexity
  async asyncData({ params, error, navInit, script }) {
    try {
      const pathArr = params.pathMatch.split('/').filter(path => !!path);
      const pathlen = pathArr.length;
      if (!pathlen) {
        error({
          statusCode: 404,
          message: '404 Not Found',
        });
        return;
      }
      const [modulePath] = pathArr;
      const isNewsDetailShow = pathlen >= 2 ? true : false;
      let newsList = [];
      let news = {};
      let totalItem = 0;
      let articleInfo = {};
      // 获取文章列表
      if (!isNewsDetailShow) {
        news = await getCategoryListApi({
          path_map: `/news/${modulePath}`,
          page_index: 1,
          page_size: PAGE_SIZE,
        });
        totalItem = news.total;
        newsList = handleNewsList(news.categorys, modulePath);
      }
      // 获取文章详情
      else {
        news = await getCategoryListApi({
          path_map: `/news/${modulePath}`,
        });
        articleInfo = handleArticle(news.categorys, pathArr[1]);
        // 判断路径是否合理存在
        if (!articleInfo.isValidPath) {
          error({
            statusCode: 404,
            message: '404 Not Found',
          });
          return;
        }
        // 获取文章内容
        articleInfo.html = await getArticleContent(articleInfo.category_id);
      }
      return {
        modulePath,
        isNewsDetailShow,
        newsList,
        totalItem,
        articleInfo,
        navInit,
        script,
      };
    } catch (err) {
      console.error(err);
      errorLogger(err);
    }
  },
  data() {
    return {
      isNewsDetailShow: false,
      newsList: [],
      totalItem: 0,
      currentPage: 1,
      findedNavConfig: {},
      pageSize: PAGE_SIZE,
      isExternalLink: util.isExternalLink,
    };
  },
  computed: {
    pathArr() {
      return this.$route.params.pathMatch.split('/').filter(path => !!path);
    },
  },
  mounted() {
    util.initPageComponents(this.navInit);
  },
  methods: {
    async onChangePage(val) {
      try {
        this.currentPage = val;
        const news = await getCategoryListApi({
          path_map: `/news/${this.modulePath}`,
          page_index: val,
          page_size: PAGE_SIZE,
        });
        this.newsList = handleNewsList(news.categorys, this.modulePath);
      } catch (error) {
        console.log(error);
      }
    },
  },
  head() {
    return {
      title: '公告中心 | 腾讯位置服务',
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },
};

function handleNewsList(news, modulePath) {
  if (!news) {
    return [];
  }
  const newsList = [];
  news.map(item => {
    const temp = {};
    const time = item.create_time.split(' ')[0].split('-');
    temp.title = item.name;
    temp.desc = item.desc;
    temp.pubtime = `${time[0]}年${time[1]}月${time[2]}日`;
    // 外链和非外链的处理
    let temppath = item.path_map;
    if (!util.isExternalLink(temppath)) {
      temppath = `/news/${modulePath}/${temppath}`;
    }
    temp.path = temppath;
    temp.article_id = item.category_id;
    newsList.push(temp);
  });
  return newsList;
}

function handleArticle(categorys, articleName) {
  const article = {};
  for (let i = 0, len = categorys.length; i < len; i++) {
    const item = categorys[i];
    if (item.path_map === articleName) {
      article.category_id = item.category_id;
      if (i > 0) {
        const temp = categorys[i - 1];
        article.preArticleName = temp.name;
        article.preArticlePath = temp.path_map;
      }
      if (i < len - 1) {
        const temp = categorys[i + 1];
        article.nextArticleName = temp.name;
        article.nextArticlePath = temp.path_map;
      }
      article.isValidPath = true;
      break;
    }
  }
  return article;
}

async function getArticleContent(id) {
  try {
    const res = await getArticleListApi({ parent_id: id });
    const contentRes = await getArticleContentApi({
      parent_id: res[0].parent_id,
      article_id: res[0].article_id,
    });
    const html = contentRes.html_content || '';
    return html;
  } catch (error) {
    console.log(error);
    return '';
  }
}

</script>

<style lang="less">
@import "./index.less";
</style>
